/**
 * Wire values match the backend's `CaseStatus` enum EXACTLY — it serializes via `@JsonProperty`
 * display strings (e.g. `ON_HOLD -> "On Hold"`), not the Kotlin constant name. Confirmed by
 * `CaseResourceTest.kt`'s `jsonPath("$.status").value("Closed")`. A prior version of this enum used
 * SCREAMING_SNAKE values ('ON_HOLD' etc.) that never matched a real API response, silently breaking
 * every `case.status === CaseStatus.X` comparison in the client (the decision card never hid once a
 * case went ON_HOLD, the escalated-successor banner never showed, canSubmitToAttorney's closed/on-hold
 * guard was dead code) — see jackson-dto-conventions.md's "Enum wire values" gotcha.
 */
export enum CaseStatus {
  OPEN = 'Open',
  IN_PROGRESS = 'In Progress',
  ON_HOLD = 'On Hold',
  CLOSED = 'Closed',
  ARCHIVED = 'Archived'
}
